var save_id = 0;
var cpt_save = 0;
var from_range = false;  //for wishlist

if (typeof(click_and_go_click) == 'undefined') {
    var click_and_go_click = false;
}

function addEvent(elem,event,name_function) {

    if(document.all) elem.attachEvent("on"+event,name_function);
    else elem.addEventListener(event,name_function,false);

}

function delEvent(elem,event,name_function) {

    if(document.all) elem.detachEvent("on"+event,name_function);
    else elem.removeEventListener(event,name_function,false);

}

// empeche les evenements de remonter dans l'arbre

function doNothing(e) {

if (document.all) {
  if (!e) var e = window.event;
  e.cancelBubble = true;
 }
 else {
    e.stopPropagation();
 }
 return false;
}
// popup guide des tailles
function showsizeguide(){
    var elname = 'sizeguidebox';

    var actualposition = document.documentElement.scrollTop;
    var modbox = document.getElementById(elname);
    var shade = document.getElementById('shade');
    modbox.style.position = "absolute";
    shade.style.display="block";

    addEvent(shade,'click',closesizeguide);

    addEvent(document.getElementById('menu_sizeguide'), 'click', doNothing);

    modbox.style.display="block";

    window.scrollTo(0,actualposition);
}

function closesizeguide() {
    var elname = 'sizeguidebox';
    var shade = document.getElementById('shade');
    var modbox = document.getElementById(elname);
    modbox.style.display="";

    delEvent(shade,'click',closesizeguide);
    delEvent(modbox,'click',closesizeguide);
    delEvent(document.getElementById('menu_sizeguide'), 'click', doNothing);
    closemodal();
}

var addToCartTmpl;

/**
 * Lancer de l'ajout au panier
 * @param products
 * @param type
 * @param root
 * @param id_produit
 * @param is_not_produit
 */
function newshowmodal(products, type, root, id_produit, is_not_produit)
{
    topProductAppear();
    window.setTimeout(function () {

        topProductDesappear()
    }, 5000);
}

function showsendfriendmodal(product_id, path_web, type) {

    var elname = (type === 'look_basket') ? 'modbox' : 'sendfriendbox';
    var actualposition = document.documentElement.scrollTop ;

    if (type !== 'look_basket') {

        document.getElementById('product_sendfriend_nok').innerHTML = '';
        document.getElementById('product_sendfriend_ok').innerHTML = '';
        document.getElementById('product_sendfriend_nok').style.display = 'none';
        document.getElementById('product_sendfriend_ok').style.display = 'none';

        openMultiShad('sendfriendbox');

    } else {

        openMultiShad(elname);
        reloadLookparts();
        $('.loader', '#bloc_add_basket').hide();
    }
}

function closesendfriendmodalfromconfirm() {

    closeMultiShad('sendfriendbox');

    document.body.style.overflow='';
    document.getElementsByTagName("html")[0].style.overflow = "";
    document.getElementById('sendfriend_form_to').style.display="block";
    document.getElementById('sendfriend_form_froms').style.display="block";
    document.getElementById('sendfriend_form_buttons').style.display="block";
    document.getElementById('sendfriend_alert_mail').innerHTML="";
    document.getElementById('sendfriend_alert_mail').style.display="none";

    if ( navigator.userAgent.indexOf('MSIE') != -1 && navigator.userAgent.indexOf('6.') != -1 ) {

        var svn=document.getElementsByTagName("SELECT");
        for (a=0;a<svn.length;a++){
            svn[a].style.visibility="visible";
        }
    }
}

function waitingAddToBasket(evt, form_elm, from, itm_rr_id) {
    var id = '';
    var produit_id = form_elm.getValue('produit_id');
    var suff = form_elm.getValue('suff');
    var panier_id = form_elm.getValue('panier_id');
    var titreObjet = form_elm.getValue('titreObjet');
    var idTaille = form_elm.getValue('idTaille');
    var lastTaille = form_elm.getValue('lastTaille');
    var idCouleur = form_elm.getValue('idCouleur');
    var lastCouleur = form_elm.getValue('lastCouleur');
    var toEval = form_elm.getValue('toEval');
    var page_name = form_elm.getValue('page_name');
    var path_web = form_elm.getValue('path_web');
    var enable_omniture = form_elm.getValue('enable_omniture');
    var is_not_produit = form_elm.getValue('is_not_produit');
    var is_lightbox_specifique = form_elm.getValue('is_lightbox_specifique');
    var is_achat_express = $('#is_achat_express_v2').val() == 1;
    var loader;

    var form_id = form_elm.getAttribute('id');
    var fk_produit_id = $("#" +  form_id).find('.prodSize').filter(':checked').data('produitid');

    if(!is_achat_express)
        evt.preventDefault();

    if (from === undefined) {

        from = '';
    }

    if (is_not_produit == true) {

        id += '_' + produit_id;
    }

    if (this.nextElementSibling && this.nextElementSibling.classList.contains('loader')) {

        loader = $(this.nextElementSibling);

        loader.addClass("loading");
    } else {

        $("#bloc_btn_active" + id).attr('class', 'cache');
        $("#bloc_btn_loader" + id).attr('class', 'f_right');
    }

    if (is_lightbox_specifique == 'true') {

        add_produit_specifique(produit_id, idCouleur, idTaille);
    } else {

        window.setTimeout(addToBasket, 1000, produit_id, suff, panier_id, titreObjet, idTaille, lastTaille, idCouleur, lastCouleur, toEval, page_name, path_web, enable_omniture, is_not_produit, from, loader, is_achat_express, itm_rr_id, fk_produit_id);
    }
}

function addToBasket(produit_id, suff, panier_id, titreObjet, idTaille, lastTaille, idCouleur, lastCouleur, toEval, page_name, path_web, enable_omniture, is_not_produit, from, loader, is_achat_express, itm_rr_id, fk_produit_id) {

    var id = '';
    var prix_id = 'prixU';

    if (itm_rr_id === undefined) {
        itm_rr_id = '';
    }

    if (from == 'basket' || is_not_produit == true || is_achat_express) {

        id += '_' + produit_id + itm_rr_id;
        prix_id = 'prixU' + id;

        if (is_not_produit == true) {

            var code_color = $('#couleurUnique' + id).text();
            var nom_color = $('#couleurUnique' + id).text();
        }
    }

    var send_produit_id = produit_id;
    if (typeof fk_produit_id !== 'undefined' && fk_produit_id != '') {
        send_produit_id = fk_produit_id;
    }

    var prix = '';
    if (document.getElementById(prix_id)) {
        prix = document.getElementById(prix_id).value;
    }

    var array_panier = newUpdatePanier(send_produit_id, suff, panier_id, prix, path_web, titreObjet, idTaille, lastTaille, idCouleur, lastCouleur);

    if (array_panier != false) {

        if (from == 'basket') {

            location.reload();

            return false;
        }

        var type = '';

        if (array_panier[1] == 'false' || array_panier.length == 0) {

            type = 'err';
        }

        omnitureEvent = '';

        if (array_panier[1] == 1) {

            omnitureEvent = 'scOpen,scAdd'; // le premier produit ajout� au panier
        } else {

            omnitureEvent = 'scAdd'; // il y a d�j� un produit au panier
        }

        if (loader) {

            loader.parent().removeClass('loading');
            loader.removeClass('loading');

        } else {

            $("#bloc_btn_active" + id).attr('class', '');
            $("#bloc_btn_loader" + id).attr('class', 'f_right cache');
        }

        if (array_panier[1] > 0 && enable_omniture == true) {

            void(s.t());
            s.pageName = "'" + page_name + "'";
            s.products = ";" + produit_id;
            s.events = omnitureEvent;
            void(s.t());
        }

        if (array_panier.length >= 0 && array_panier[5] !== undefined) {
            var dl_objet = array_panier[5];
            if (is_achat_express) {
                var new_dl_objet = JSON.parse(dl_objet)
                new_dl_objet.ecommerce.is_achat_express = true;
                dl_objet = JSON.stringify(new_dl_objet);

            }
            pushIntoDatalayer(dl_objet);
        }

        if (typeof dataLayer_v3 !== 'undefined' ) {
            if (array_panier.length >= 0 && array_panier[6] !== undefined) {
                var dlv3_objet = JSON.parse(array_panier[6]);
                DataLayerTrigger.addToCart(dlv3_objet['items'], dlv3_objet['actionField'], is_achat_express);
            }
        }

        // Managing stock taunt text display
        if ($('#arrayIdCabas').length) {
            var arrayIdCabas = $('#arrayIdCabas').val().split(',');

            setAvailableSizesCabas(arrayIdCabas);
        }

        // Mise à jour du panier top
        var response_basket = ajax_file(path_web + 'ajax_show_basket.php');

        $("#cart_top").html(response_basket);
        $("#cart_list").lionbars();
        $( "#cart_top" ).on('mouseenter touchstart', function(evt) {
            $("#cart_list").lionbars();
        });

        $("#lightbox_achat_express, .lightbox_achat_express, #shad").hide();

        newshowmodal(produit_id, is_not_produit);
    } else {

        if (loader) {

            loader.parent().removeClass('loading');
        } else {

            $("#bloc_btn_active" + id).attr('class', '');
            $("#bloc_btn_loader" + id).attr('class', 'f_right cache');
        }
    }

    eval(toEval);

    if (array_panier != false) {

        if (navigator.userAgent.indexOf('MSIE') != -1 && navigator.userAgent.indexOf('6.') != -1) {

            var svn = document.getElementsByTagName("SELECT");

            for (a = 0; a < svn.length; a++) {

                svn[a].style.visibility = "hidden";
            }
        }

        if (click_and_go_click) {
            click_and_go_click = false;
            location.href = path_relative_root + create_link('order_livraison_choix');
        }
    } else {
        if (click_and_go_click) {
            click_and_go_click = false;
        }
    }

    return false;
}

function updateSrc(path_web,dest) {
    var tmp_string_large = document.getElementById('img_large').src;
    tmp_string = tmp_string_large.replace(/medium/,"large");

    document.getElementById('img_large').setAttribute('onclick','zoomImg(\''+tmp_string+'\',\''+path_web+'\')');
    document.getElementById('loupe').href = 'javascript:zoomImg(\''+tmp_string+'\',\''+path_web+'\');';
    $(".zoomLens").css({backgroundImage : 'url("'+tmp_string_large+'")' });

    if(dest=='vue') {

        var i = 0;
        var trouve = false;
        while (i<tab_js.length && !trouve) {

            trouve = (tab_js[i][0].substring(tab_js[i][0].lastIndexOf('/')+1)==tmp_string.substring(tmp_string.lastIndexOf('/')+1));
            i++;

        }

        cpt_img = (i-1);

    }
}

function productSendFriendForm(path_web, request_uri) {

    document.getElementById("product_sendfriend_ok").style.display = 'block';
    document.getElementById("product_sendfriend_nok").style.display = 'block';

    if ( document.getElementById('sendFriendToMails') && document.getElementById('sendFriendToMessage') && document.getElementById('sendFriendYourName') && document.getElementById('sendFriendYourMail') && document.getElementById('sendFriendCopy') ) {
        document.getElementById('sendFriendToMails').style.border="";
        document.getElementById('sendFriendToMessage').style.border="";
        document.getElementById('sendFriendYourName').style.border="";
        document.getElementById('sendFriendYourMail').style.border="";

        var token = document.getElementById('token_security_sendfriend').value;
        var captcha = document.getElementById('g-recaptcha-response').value;

        var params_add = '';
        if(document.getElementById("produit_id")) {
            params_add +=  '&product_id='+document.getElementById("produit_id").value;
        }

        $.ajax({
            url: path_web + 'ajax_send_friend_form.php',
            type: 'POST',
            data: 'g-recaptcha-response=' + captcha + '&token_security=' + token + '&url=' + request_uri + '&to_mails=' + document.getElementById('sendFriendToMails').value + '&to_message=' + document.getElementById('sendFriendToMessage').value.replace(/\n/g,'<br>') + '&your_name=' + document.getElementById('sendFriendYourName').value + '&your_mail=' + document.getElementById('sendFriendYourMail').value + '&copy=' + document.getElementById('sendFriendCopy').checked + params_add
        }).done(function(response) {

            var content_id = 'product_sendfriend_nok',
                content = '';

            if (response.split(',')[0] == 'ok') {

                var s_adresse = response.substr(3);
                var sing = (response.split(',').length > 2) ? 'sendfriend_ok_plur' : 'sendfriend_ok_sing';

                content = '<div style="font-size:14px;font-weight:bold;font-family:Arial; color:#222;text-align:center;margin-bottom:10px;margin-top:15px;font-family: arial;">'+ajax_file(path_web+'ajax_sprintf.php?arg1='+sing)+'</div>';
                content += '<p style=\"margin-top: 0px;margin-bottom: 30px;padding:0;text-align:center;\">'+s_adresse+'</p>';

                content_id = "sendfriend_alert_mail";

                document.getElementById('product_sendfriend_nok').innerHTML = "";
                document.getElementById('sendfriend_form_to').style.display = "none";
                document.getElementById('sendfriend_form_froms').style.display = "none";
                document.getElementById('sendfriend_form_buttons').style.display = "none";
                document.forms["sendfriendform"].reset();

                $(".form_submit.loading", "#sendfriendform").removeClass("loading");
            } else {

                $('#sendFriendToMails').removeClass('inputErr');
                $('#sendFriendToMessage').removeClass('inputErr');
                $('#sendFriendYourName').removeClass('inputErr');
                $('#sendFriendYourMail').removeClass('inputErr');

                if ($('#sendFriendToMessage').val() == '')
                    $('#sendFriendToMessage').addClass('inputErr');
                if ($('#sendFriendYourName').val() == '')
                    $('#sendFriendYourName').addClass('inputErr');
                if ($('#sendFriendYourMail').val() == '')
                    $('#sendFriendYourMail').addClass('inputErr');

                content = "<img src=\""+path_relative_root+"img/picto_panneau.png\" style=\"margin-right:10px;float:left;\" loading=\"lazy\" decoding=\"async\"/><p style=\"margin: 0px;padding: 0px; line-height: 24px;\">" + ajax_file(path_web+'ajax_sprintf.php?arg1=error_fields') + "</p>";

                if (response == '1' ) {

                    content = "<img src=\""+path_relative_root+"img/picto_panneau.png\" style=\"margin-right:10px;float:left;\" loading=\"lazy\" decoding=\"async\"/><p style=\"margin: 0px;padding: 0px; line-height: 24px;\">" + ajax_file(path_web+'ajax_sprintf.php?arg1=sendfriend_error_no_mail_friends') + "</p>";
                    $('#sendFriendToMails').addClass('inputErr');
                    $('td.labelForm').addClass('labelErr');

                } else if (response == '2' ) {

                    content = "<img src=\""+path_relative_root+"img/picto_panneau.png\" style=\"margin-right:10px;float:left;\" loading=\"lazy\" decoding=\"async\"/><p style=\"margin: 0px;padding: 0px; line-height: 24px;\">" + ajax_file(path_web+'ajax_sprintf.php?arg1=sendfriend_error_mail_friends_invalid') + "</p>";
                    $('#sendFriendToMails').addClass('inputErr');
                    $('td.labelForm').addClass('labelErr');

                } else if (response == '6' ) {

                    content = "<img src=\""+path_relative_root+"img/picto_panneau.png\" style=\"margin-right:10px;float:left;\" loading=\"lazy\" decoding=\"async\"/><p style=\"margin: 0px;padding: 0px; line-height: 24px;\">" + ajax_file(path_web+'ajax_sprintf.php?arg1=sendfriend_error_no_my_mail') + "</p>";
                    $('#sendFriendYourMail').addClass('inputErr');
                    $('td.labelForm').addClass('labelErr');

                } else if (response == '7' ) {

                    content = "<img src=\""+path_relative_root+"img/picto_panneau.png\" style=\"margin-right:10px;float:left;\" loading=\"lazy\" decoding=\"async\"/><p style=\"margin: 0px;padding: 0px; line-height: 24px;\">" + ajax_file(path_web+'ajax_sprintf.php?arg1=sendfriend_error_my_mail_invalid') + "</p>";
                    $('#sendFriendToMails').addClass('inputErr');
                    $('td.labelForm').addClass('labelErr');

                } else if (response == 'token_error' ) {

                    content = "<p class=\"txt_err_sendfriend\">" + ajax_file(path_web+'ajax_sprintf.php?arg1=error_token_security') + "</p>";

                } else if (response == '3' || response == '4' || response == '5') {
                    $('#sendFriendToMessage').addClass('inputErr');
                    $('#sendFriendYourName').addClass('inputErr');
                } else {

                    var s_adresse = response.substr(3);
                    var sing = (response.split(',').length > 2) ? 'sendfriend_no_ok_plur' : 'sendfriend_no_ok_sing';

                    content = '<div class="msg_poperror">' + Translator.translate(sing) + '</div>';
                    content_id = "sendfriend_alert_mail";
                    content +=
                        '<div class="form_submit">' +
                            '<a class="button primary" href="#" onclick="closesendfriendmodalfromconfirm()">' +
                                '<span>' + Translator.translate("ok") + '</span>' +
                            '</a>' +
                        '<div>';

                    document.getElementById('product_sendfriend_nok').innerHTML = "";
                    document.getElementById('sendfriend_form_to').style.display = "none";
                    document.getElementById('sendfriend_form_froms').style.display = "none";
                    document.getElementById('sendfriend_form_buttons').style.display = "none";

                    document.getElementById('sendFriendToMails').value = "";
                    document.getElementById('sendFriendToMessage').value = "";
                    document.getElementById('sendFriendYourName').value = "";
                    document.getElementById('sendFriendYourMail').value = "";

                    $(".form_submit.loading", "#sendfriendform").removeClass("loading");
                }
            }

            document.getElementById(content_id).innerHTML = content;
            document.getElementById(content_id).style.display = 'block';
            $('#sendfriend_form_buttons').removeClass('loading');

        });
    }

    return false;
}

function fbs_click( site, params ){

    if ( params == '' ){
        params = location.href;
    }

    switch ( site ){
        case 'fb':
            window.open('http://www.facebook.com/share.php?u='+encodeURIComponent(params)+'&t=');
        break;
        case 'tw':
            window.open('https://twitter.com/share?url='+params);
        break;
        case 'insta':
            window.open('https://www.instagram.com/vanessabruno/');
            break;
        case 'pin':
            window.open('http://pinterest.com/pin/create/button/?'+params);

            var url = params.split('&');
            url = url[0].split('=');
            url = decodeURIComponent( url[1] );
        break;
    }
    return false;
}

/**
 * Dans la fiche produit affiche un champs email pour que l'ont previenne que le produit est disponible
 */
function lightboxAlertStock() {

    var $taille_id = $("#tailleProd").val(),
        $couleur_id = $("#couleurProd").val();

    if ($taille_id == '') {
        if (!$('#sizeerror').is(':visible')) {
            $('#sizeerror').slideDown();
        }
        return;
    } else if ($couleur_id == '') {
        alertV2(Translator.translate('js_error_couleur'));
        return;
    }

    if ($('.fp_cabas').length) {
        $('#keep_alive_stock').slideDown();
    }

    $('.bloc_add_alert_form').show();
}

function closeAlertStock() {
    $('.bloc_add_alert_confirmation').hide();
}

function alertStockFP() {
    const $productPage = $('.product_page');

    // Initially hide all #keep_alive_stock elements within .product_page
    $productPage.find('#keep_alive_stock').hide();

    // Handle clicks on .size_list .form_itm .disabled
    $(document).on('click', '.size_list .form_itm .disabled', function () {
        const $parentPage = $(this).closest('.product_page');
        $parentPage.find('#keep_alive_stock').show();
        $parentPage.find('.bloc_add_alert_confirmation').hide();
        lightboxAlertStock();
    });
}

/**
 * Sends a mail alert for stock.
 *
 * @param {string} type_alert - The type of alert.
 * @param {object} form - The form object.
 * @param {string} itm_rr_id - The itm_rr_id value.
 */
function sendMailAlertStock(type_alert, form, itm_rr_id) {

    var id = form.getValue('produit_id');
    var is_achat_express = $('#is_achat_express_v2').val() == 1;
    var elem = '';

    if (is_achat_express) {
        elem = '_' + id;
        if (itm_rr_id) {
            elem += itm_rr_id;
        }
    }

    var $produit_id = $('#produit_principal' + elem).val(),
        $taille_id = $("#tailleProd" + elem).val(),
        $couleur_id = $("#couleurProd" + elem).val();

    var inputEmail = form.elements['mail_alerte_stock'];
    var inputEmailBis = document.getElementsByClassName('expressAlertStock');
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if (inputEmail.value === '' || !inputEmail.value.match(mailformat)) {
        $(inputEmail).addClass('inputErr');
        $(inputEmailBis).addClass('inputErr1');

    } else {
        var bloc_alert = $('#bloc_add_alert' + elem);

        if (isGlobalEActive && !enable_gbe_sfs) {
            type_alert = "stock_gbe";
        }

        $.ajax({
            type : 'post',
            url : path_relative_root + create_link('ajax_mail_alert_stock'),
            data : {
                email : inputEmail.value,
                produit_id : $produit_id,
                taille_id : $taille_id,
                couleur_id : $couleur_id,
                type_alert : type_alert
            },
            success : function(response) {
                var dataLayer = window.dataLayer || [];
                pushToWshopBus({
                    "event": "alert_outOfStock",
                    "produit_id" : $produit_id,
                });
                $('.bloc_add_alert_form', bloc_alert).hide();
                $('.bloc_add_alert_erreur', bloc_alert).hide();
                $('.bloc_add_alert_confirmation', bloc_alert).fadeIn();
                $(inputEmailBis).addClass('success1');
                $('.cart.step_1 .expressAlertStock .alert_return').show();
            },
            fail : function () {

                $('.bloc_add_alert_confirmation', bloc_alert).fadeOut();
                $('.bloc_add_alert_erreur', bloc_alert).show();
                $('.cart.step_1 .expressAlertStock .bloc_add_alert_erreur').show();
            }
        });
    }
}

// alert stock wishlist basket
function openAlerteStock() {
    $('.cart.step_1 .expressAlertStock .alert_stock').hide();
    $('.cart.step_1 .expressAlertStock .bloc_add_alert_form').fadeIn();
}

// alert stock wishlist basket
function closeAlerteStockWishlist() {
    var $alertStockContainer = $('.cart.step_1 .expressAlertStock');
    $alertStockContainer.find('.expressAlertStock, .bloc_add_alert_confirmation, .alert_return').hide();
    $alertStockContainer.find('.alert_stock').fadeIn();
    $alertStockContainer.show();
    $alertStockContainer.removeClass('success1 inputErr1');
}

function closeAlerteStock(id) {
    var elem = '_' + id;
    var prodInfoElt = $('#prod_info' + elem);
    var blocAlert = $('#bloc_add_alert' + elem);
    blocAlert.hide();
    // On decoche la taille
    $('input[name="itm_size"]:checked', prodInfoElt).prop('checked', false);
    // hide alert message after closure
    $('.bloc_add_alert_confirmation').hide();
}

//Description FP
$(document).on("click", ".product_detail_wrapper .product_detail_title", function(e) {
    'use strict';

    //hide all span
    var elt = $(this);
    var detailLabel = elt.attr("data-detail-label");

    $(elt).siblings('.product_detail_content').slideToggle();
    $(this, elt).toggleClass("active");

    if (typeof dataLayer_v3 !== 'undefined' && dataLayer_v3 !== '' && dataLayer_v3 !== null) {
        if (detailLabel !== undefined && detailLabel !== '') {

            TriggerProductDetailClick(detailLabel);
        }
    }

});

/*Zoom sliders*/

function zoomImg(slide) {
    $('#zoom_box_wrapper').css('opacity', 0);
    if($(".productLightboxVisu").length > 0) {
        $(".productLightboxVisu img").on('click touch', function(){
            closeMultiShad('zoomBox');
        });
    }
    if($("#thumbs_scroller").length > 0) {
        // Thumbs are rendered server-side as picture/source markup, one zoom-thumb per gallery
        // image, videos already excluded (see buildZoomSlide/pictures_detail_zoom): just wire up navigation.
        $("#thumbs_scroller .swiper-slide").attr('onclick', function (i) {
            return 'zoomImg(' + i + ')';
        });

        var zoomThumbs = new Swiper('#thumbs_scroller', {
            direction: 'vertical',
            slidesPerView: 4,
            initialSlide: slide,
            observer: true,
            observeParents: true,
            mousewheel: true,
            navigation: {
                nextEl: '.thumbsNext',
                prevEl: '.thumbsPrev',
            },
        });

        $(".productVisu").each(function (index) {
            $(this).removeClass('active_slide');
        });

        $(".productVisu#nbr_visu_" + slide).addClass('active_slide');

        // data-zoom-src is set on the zoom-thumb's own img (see buildZoomSlide's pictureAttributes),
        // not on the FP visual_scroller img which has no such attribute.
        // Note: img.img_zoom currently has no <source> siblings (no preset on that picture), so
        // swapping its src is enough; if a 'zoom' preset with srcset is added later, update this too.
        var src = $("#thumbs_scroller .productVisu#nbr_visu_" + slide + " img").attr('data-zoom-src');
        $('#zoom_box_wrapper img.img_zoom').attr('src', src);
    }

    window.setTimeout(function () {
        $('#zoom_box_wrapper').animate({opacity: 1}, 650);
    }, 350);

    openMultiShad('zoomBox');
}

jQuery(document).ready(function(){
    jQuery('.scrollbar-external').scrollbar({
        "autoScrollSize": false,
        "scrolly": $('.external-scroll_y')
    });
});

function updateSizeSelectButton(element) {
    //Copy the size label content to the size selection CTA
    var $sizeSelectCta = $('#size_select_cta');
    if (element.classList.contains('disabled')) {
        $sizeSelectCta.addClass('out_of_stock');
    } else {
        $sizeSelectCta.removeClass('out_of_stock');
    }

    // SW-22321 : le CTA recoit le contenu du label, il doit donc reprendre son etat "Dernieres pieces"
    $sizeSelectCta.toggleClass('last_stock', element.classList.contains('last_stock'));
    $sizeSelectCta.empty();
    $sizeSelectCta.addClass('size_selected');
    $sizeSelectCta.append(element.innerHTML);
}

function selectFPLightboxColor(element) {
    var id = element.getAttribute('data-color-id');
    $('#color_' + id).click();
    $('.color_select_clone.selected').removeClass('selected');
    element.classList.add('selected');
    closeMultiShad('show_all_colors_lightbox');
}

function updateFPLightboxColor() {
    var id = $('.input_check.prodColor:checked').val();
    $('[data-color-id="' + id + '"]').addClass('selected');
}

$(function (){

    setTimeout(function () {
        $(".store_locator").not('#stepStoreList').lionbars();

    }, 2500);

    // PRODUCT SWIPER
    if($("#visual_scroller .swiper-slide").length) {
        var productThumbs = new Swiper('#visual_scroller', {
            slidesPerView: 4,
            spaceBetween: 17,
            direction: 'vertical',
            loop: false,
            navigation: {
                nextEl: '.thumbNext',
                prevEl: '.thumbPrev',
            },
        });
    } else {
        $("#visual_scroller_wrapper").addClass('no_swiper');
    }

    if($("#jqzoom .swiper-slide").length > 1) {
        //animation to avoid slide's width transition on pageload
        $('#jqzoom').animate({
            opacity: 1,
        },10);
        var main_productVisu = new Swiper('#jqzoom', {
            thumbs: {
                swiper: productThumbs
            },
            pagination: {
                el: '.swiper-pagination',
                type: "bullets",
                clickable: true
            },
            slidesPerView: 1,
            loop: false,
            on: {
                slideChange: function() {
                    loadSlideImages(this.slides[this.activeIndex]);
                }
            }
        });
    }
    if ($("body").hasClass("product_page")) {
        var swiper_FP_main_push_width = $("#jqzoom").width();

        $(window).on("load", function() {
            setTimeout(function() {
                var swiper_FP_main_push_height = $("#jqzoom .swiper-wrapper.productBigPictures .img_large").height();

                $("#visual_scroller").height(swiper_FP_main_push_height);
            }, 250)
        });

        $(window).on('resize', function () {
            setTimeout(function(){
                var swiper_FP_main_push_height = $("#jqzoom .swiper-wrapper.productBigPictures .img_large").height();
                var swiper_FP_main_push_width = $("#jqzoom").width();

                $("#visual_scroller").height(swiper_FP_main_push_height);
            }, 250)
        });
    }

    // Show popin Trace for good
    $(".trace_for_good_title").on("click", function() {
        $('#traceForGoodLightbox').addClass('actif').removeClass('closing');
    });

    // Close lightbox
    $("#traceForGoodLightbox .close_pop, #shad").on("click", function() {
        if ($('#traceForGoodLightbox').hasClass('actif')) {
            $('#traceForGoodLightbox').removeClass('actif').addClass('closing');
        }
    });

    alertStockFP();

    $(".btnAddBasketWrapper").on("click", function() {
        if (!$('#size_select_cta').hasClass("size_selected")) {
            openSizeSelection();
        }
    });

    // Close size selection when clicking outside
    $(document).on("click", function(event) {
        if ((!$(event.target).closest('.size_selection_wrapper').length) && (!$(event.target).closest('.btnAddBasketWrapper').length)) {
            $('.size_selection_wrapper').removeClass('open');
        }
    });

    if ($('#show_all_colors_lightbox').length) {
        updateFPLightboxColor();
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const productGroup = document.querySelector('.itm_form_group_flex');

    // Check if the product group has the "cabas" class
    if (productGroup && productGroup.classList.contains('cabas')) {
        const colorInputs = document.querySelectorAll('#color_list_wrapper .input_check.radio.prodColor.color');

        // If only one color option is available
        if (colorInputs.length === 1) {
            const onlyColorInput = colorInputs[0];
            onlyColorInput.checked = true;

            // Trigger the "change" event manually
            const changeEvent = new Event('change', { bubbles: true });
            onlyColorInput.dispatchEvent(changeEvent);

            const colorContainer = onlyColorInput.closest('.form_itm');
            if (colorContainer) {
                colorContainer.classList.add('selected');
            }
        }
    }
});
